<template>
  <!--
    	作者：luoyiming
    	时间：2020-04-26
    	描述：门店-添加门店
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form
      size="small"
      ref="dataForm"
      :model="form"
      label-width="120px"
      :rules="rules"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="分类管理" name="first">
          <el-form-item label="一级分类名称" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入一级分类名称"
              class="max-w460"
            ></el-input>
          </el-form-item>
          <el-form-item label="分类排序">
            <el-input
              type="number"
              v-model="form.sort"
              placeholder="请输入序号"
              class="max-w460"
            ></el-input>
          </el-form-item>
          <el-form-item label="封面图片" prop="image_id">
            <el-row>
              <el-button
                icon="el-icon-picture-outline"
                @click="openUpload($event, '1')"
                >选择图片</el-button
              >
              <div v-if="form.image_id != ''" class="img">
                <img :src="file_path" width="100" height="100" />
              </div>
            </el-row>
          </el-form-item>
          <el-form-item label="详情图片" prop="detail_image_id">
            <el-row>
              <el-button
                icon="el-icon-picture-outline"
                @click="openUpload($event, '2')"
                >选择图片</el-button
              >
              <div v-if="form.detail_image_id != ''" class="img">
                <img :src="detail_file_path" width="100" height="100" />
              </div>
            </el-row>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="抽盒配置" disabled name="second">
          <el-form-item label="销售状态：">
            <el-radio-group v-model="form.state">
              <el-radio :label="1">立即上架</el-radio>
              <el-radio :label="0">放入仓库</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="价格类型：">
            <el-radio-group v-model="form.show_type" @change="changeShowType">
              <el-radio :label="1">点券</el-radio>
              <el-radio :label="2">积分</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="点券价格：" width="80" v-if="form.show_type === 1" prop="bonds_price">
            <el-input
              type="number"
              v-model="form.bonds_price"
              class="max-w460"
            ></el-input>
          </el-form-item>

          <el-form-item label="积分价格：" width="80" v-if="form.show_type === 2"  prop="point_num">
            <el-input
              type="number"
              v-model="form.point_num"
              class="max-w460"
            ></el-input>
          </el-form-item>

          <el-form-item label="大保底类型：" width="80" prop="jackpot">
            <el-select v-model="form.jackpot" placeholder="请选择大保底类型">
              <el-option :value="0" :label="'全部'"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="大保底重置包数："
            width="80"
            prop="jackpot_reset_num"
          >
            <el-input
              type="number"
              v-model="form.jackpot_reset_num"
              class="max-w460"
              placeholder="多少包能出一个大保底"
            ></el-input>
          </el-form-item>

          <el-form-item label="十连抽保底类型：" width="80" prop="ten_reward">
            <el-select
              v-model="form.ten_reward"
              placeholder="请选择十连抽保底类型"
            >
              <el-option :value="0" :label="'全部'"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="规则说明" prop="rule_description">
            <!-- <el-input type="textarea" v-model="form.rule_description" class="max-w460"></el-input> -->
            <div class="edit_container">
              <Uediter
                v-model="form.rule_description"
                :text="ueditor.text"
                :config="ueditor.config"
                ref="ue"
              ></Uediter>
            </div>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="onSubmit('dataForm')"
          :loading="loading"
          >提交</el-button
        >
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload
      v-if="isupload"
      :isupload="isupload"
      :type="type"
      @returnImgs="returnImgsFunc"
      >上传图片</Upload
    >
  </div>
</template>

<script>
import codeApi from "@/api/code.js";
import Upload from "@/components/file/Upload";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    Uediter,
    Upload,
  },
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        name: "",
        sort: 0,
        image_id: "",
        rule_description: "无",
        state: 0,
        point_num: 0,
        bonds_price: 0,
        show_type: 1,
        jackpot: "",
        jackpot_reset_num: 0,
        ten_reward: "",
        detail_image_id: "",
      },
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500,
        },
      },
      activeName: "first",
      category: [],
      file_path: "",
      uploadType: "",
      detail_file_path: "",
      /*是否上传图片*/
      isupload: false,
      loading: false,
      rules: {
        name: [{ required: true, message: "请填写分类名称", trigger: "blur" }],
        image_id: [
          { required: true, message: "请选择分类封面图片", trigger: "blur" },
        ],
        detail_image_id: [
          { required: true, message: "请选择详情图片", trigger: "blur" },
        ],
        //rule_description: [{ required: true, message: '请填写规则说明' }],
        //bonds_price: [{ required: true, message: '请填写点券价格' }],
        //point_num: [{ required: true, message: '请填写积分价格' }],
        //stock: [{ required: true, message: '请填写库存' }]
      },
    };
  },
  created() {},

  methods: {
    changeShowType() {
      this.$refs.dataForm.clearValidate()
    },
    /*添加用户*/
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let self = this;
          let form = self.form;
          self.loading = true;
          self.form.rule_description = this.$refs.ue.getUEContent();
          codeApi
            .cateAdd(form, true)
            .then((data) => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: "恭喜你，添加成功",
                  type: "success",
                });
                self.$router.push("/card/category/index");
              } else {
                self.loading = false;
              }
            })
            .catch((error) => {
              self.loading = false;
            });
        } else {
          this.$message.error("请完善必填信息");
          return false;
        }
      });
    },

    /*上传*/
    openUpload: function (e, uploadType) {
      this.uploadType = uploadType;
      this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.uploadType == "1") {
          this.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        } else {
          this.detail_file_path = e[0].file_path;
          this.form.detail_image_id = e[0].file_id;
        }
      }
      this.isupload = false;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/card/category/add.vue